/**
 * @module project/components/participate_form/form_buttons
 */
import idx from 'idx';
import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import { PARTICIPATE_FORM_STEPS, PARTICIPATE_FORM_FLOW } from 'common/variables';
import AnimatedButton from 'common/components/animated_button';
import filter from 'lodash/filter';

/**
 * Participate form buttons component
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class ParticipateButtons extends Component {
  constructor(props) {
    super(props);

    this.onChangeStep = this.onChangeStep.bind(this);
  }

  onChangeStep(event) {
    const { entries, project, user } = this.props;

    event.preventDefault();
    event.persist();

    // for `info` step we handle the change
    // via the participate form
    if (this.props.action) {
      this.props.action();

      return;
    }

    const userId = idx(user, _ => _.id);
    const userEntries = filter(entries, ({ author }) => (author === userId));
    let nextStep = PARTICIPATE_FORM_STEPS.upload;
    const stepIndex = PARTICIPATE_FORM_FLOW.indexOf(this.props.currentStep);
    nextStep = PARTICIPATE_FORM_FLOW[stepIndex + 1];

    /* If on intro step, decide next step based on entry type and number of entries */
    if (this.props.currentStep === PARTICIPATE_FORM_STEPS.intro) {
      /* name entry type: no revisions and no image upload required, go straight to info step */
      if (project.entry_type === 'name') {
        nextStep = PARTICIPATE_FORM_STEPS.info;
      /* image entry type and previous entries: allow user to submit revisions */
      } else if (Object.keys(userEntries).length > 0) {
        nextStep = PARTICIPATE_FORM_STEPS.revision;
      /* image entry type and no previous entries: go straight to image upload */
      } else {
        nextStep = PARTICIPATE_FORM_STEPS.upload;
      }
    }

    this.props.changeStep(nextStep);
  }

  render() {
    const { nextActive, currentStep, action, actionError, actionProcessing } = this.props;
    const nextButtonName = `participate_submit_${currentStep}`;
    const cancelButtonName = `participate_cancel_${currentStep}`;

    return (
      <div className="form-button-block">
        <button
          className="btn btn-text cancel"
          type="button"
          name={cancelButtonName}
          onClick={this.props.onToggleForm}
        >Cancel</button>

        {action ? <AnimatedButton
          processing={actionProcessing} label="Next" processingLabel="Processing..."
          onClick={this.onChangeStep} errorMsg={actionError} successMsg={!actionError}
          disabled={!nextActive} msgTimeout={5000}
        /> : <button
          className={classNames('btn btn-primary submit', { disabled: !nextActive })}
          type="button"
          disabled={!nextActive}
          name={nextButtonName}
          onClick={this.onChangeStep}
        >
          Next
        </button>}
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {bool} nextActive - controls if next step button is active
 * @property {string} currentStep - holds current form step
 * @property {object} entries - entries by id object
 * @property {object} project - project
 * @property {func} action - manual action to call when button is clicked (ie submit)
 * @property {string} actionError - error produced when performing action
 * @property {bool} actionProcessing - whether action is taking place
 * @property {func} changeStep - action creator to change form step
 * @property {func} onToggleForm - action creator to toggle participate form
 */
ParticipateButtons.propTypes = {
  nextActive: PropTypes.bool,
  currentStep: PropTypes.string,
  entries: PropTypes.object,
  project: PropTypes.object,
  action: PropTypes.func,
  actionError: PropTypes.string,
  actionProcessing: PropTypes.bool,
  changeStep: PropTypes.func,
  onToggleForm: PropTypes.func,
  user: PropTypes.object,
};



// WEBPACK FOOTER //
// ./project/components/participate_form/form_buttons.jsx